import { arrItems } from "data-files/items/arr-items";
import { dtItems } from "data-files/items/dt-items";
import { ewItems } from "data-files/items/ew-items";
import { hwItems } from "data-files/items/hw-items";
import { sbItems } from "data-files/items/sb-items";
import { shbItems } from "data-files/items/shb-items";
import { EorzeaDataType, GameData } from "enums";
import { Info } from "types/game";

export const items:{ [key in GameData.Item]:Info.Item } = {
	[GameData.Item.UNKNOWN]: {
		name: GameData.Item.UNKNOWN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {},
		used: [],
	},
	...arrItems,
	...hwItems,
	...sbItems,
	...shbItems,
	...ewItems,
	...dtItems,
};

// TODO: Review all items files and sort items into their respective expansion file based on when they are first used

/* Template Item Entry
	[GameData.Item.]: {
		name: GameData.Item., type: EorzeaDataType.ITEM, lodestoneID: ,
		obtained: {
			enemies: [GameData.Enemy.],
			recipes: [
				{
					itemMade: GameData.Item.,
					qtyMade: ,
					crafter: Job.,
					level: ,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item., qty:  },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]:  },
			extraction: true,
			gathering: [
				{ found: { location: GameData.MapLocation., x: , y:  }, method: GameData.GatherMethod., collectable: , timedNode: , times: [] },
			],
			fishingHoles: [
				{ fish: GameData.Fish., hole: GameData.Fishing., bait: , time: , weather: , mooch: { fish: GameData.Fish., bait: }[][]; }
			],
			shops: [
				{ shop: GameData.Shop., cost: [{ price: , currency: GameData.Currency. }] }
			],
			locations: [
				{ found: { location: GameData.MapLocation., x: , y:  }
			],
			duties: {
				trials: [Trial.],
				dungeons: [GameData.Dungeon.],
				raids: [GameData.Raid.],
				fates: [GameData.Fate.],
				leves: [GameData.Leve.],
			},
			quests: [GameData.Quest.],
			other: [{ element: , text: }]
		},
		used: [
			{ relic: [RelicData.Type., RelicData.Group., RelicData.Part., RelicData.Step., RelicData.Task.] jobs: jobLists.relic., qtyPerJob: }
		]
	},
*/
